export const InAppEndpoints = {
	GetAll: 'notification-handlers/notifications',
	Dismiss: 'notification-handlers/dismiss-notifications',
};
